import OrgTree from '../org-tree/org-tree';
import { NextLevelKey, OrgTreeItem, Company } from '@employ-engage/data';
import chunk from 'lodash.chunk';

export interface OrgTreeSelectorProps {
  onSelectOrganization: (targetDepartment: string) => void;
  companyData: Company;
  refetchCompany: () => void;
}

export function OrgTreeSelector({
  onSelectOrganization,
  companyData,
  refetchCompany,
}: OrgTreeSelectorProps) {
  const nextLevelKeys = companyData?.orgTreeNextLevelKeys || [];

  return (
    <div>
      {!!companyData && !!nextLevelKeys.length && (
        <OrgTree
          isEditable={false}
          isCollapsible
          path={[]}
          level={0}
          company={companyData as Company}
          refetchCompany={refetchCompany}
          completeOrgTree={companyData?.orgTree as OrgTreeItem}
          data={companyData.orgTree as OrgTreeItem}
          nextLevelKeys={nextLevelKeys as NextLevelKey[]}
          collapseOrganization={false}
          onSelectOrganization={(path) => {
            let ref: any = companyData.orgTree as OrgTreeItem;
            let targetDepartment = companyData.id;

            const chunks: [string, number][] = chunk(path, 2) as [
              string,
              number
            ][];
            chunks.forEach(([key, idx]) => {
              const next = ref[key]?.[idx as number] as OrgTreeItem | undefined;
              if (next && next.id) {
                targetDepartment += '.' + next.id;
                ref = next;
              }
            });
            onSelectOrganization(targetDepartment);
          }}
        />
      )}
    </div>
  );
}

export default OrgTreeSelector;
